/**
 * The name to save, or null when there's nothing to save: empty, or the name
 * it already has.
 */
export const solutionNameToSave = (
  typed: string,
  current: string | null | undefined
): string | null => {
  const name = typed.trim();
  if (!name || name === (current ?? '').trim()) return null;
  return name;
};
